const base_url = 'https://backend-test.kw.boyot.app/api/';
export const environment = {
    production: true,
    URL: base_url
};
   